import { Box as MuiBox } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FiltersBarWrapper = styled(MuiBox)`
  overflow: hidden;
`;

export const StyledFiltersBar = styled(MuiBox)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1),
}));

export const LeftSection = styled(MuiBox)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  flex: "1 0 0",
  minWidth: 0,
  flexWrap: "wrap",
}));
